import { HashLink } from "react-router-hash-link";
import { Helmet } from "react-helmet-async";
import logo from "../images/logo-removebg-preview.png";
import { useTranslation } from "react-i18next";

function Footer() {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  return (
    <>
      <Helmet>
        <title>{t("footer.seoTitle")}</title>
        <meta name="description" content={t("footer.seoDescription")} />
        <meta name="keywords" content={t("footer.seoKeywords")} />

        {/* OG Tags */}
        <meta property="og:title" content={t("footer.ogTitle")} />
        <meta property="og:description" content={t("footer.ogDescription")} />
        <meta property="og:image" content={t("footer.ogImage")} />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content={isArabic ? "ar_AR" : "en_US"} />

        {/* Contact Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Dentist",
            name: t("footer.brand"),
            image: t("footer.ogImage"),
            url: "https://saleemsmile.com",
            telephone: "+97000000000",
            address: {
              "@type": "PostalAddress",
              addressLocality: isArabic ? "رام الله" : "Ramallah",
              streetAddress: t("footer.address"),
              addressCountry: "PS",
            },
            sameAs: [
              "https://www.facebook.com/share/1GFaC9x9Np/?mibextid=wwXIfr",
              "https://www.instagram.com/saleem.smile23/",
              "https://youtube.com/@saleemsmile",
            ],
          })}
        </script>
      </Helmet>

      {/* Footer Section */}
      <footer
        className="text-light"
        id="footer"
        style={{ backgroundColor: "#202020c8" }}
        dir={isArabic ? "rtl" : "ltr"}
      >
        <div className="container py-4">
          <div className="row text-center align-items-center">
            {/* Column 1 - Address */}
            <div className="col-lg-4 col-md-12 mb-3">
              <a
                href="https://maps.app.goo.gl/2tS5e1Ub7kmmv6ia9"
                className="text-light text-decoration-none footer-link"
              >
                <i className="fa-solid fa-location-dot mx-2 text-danger"></i>
                {t("footer.address")}
              </a>
            </div>

            {/* Column 2 - Social Media Icons */}
            <div className="col-lg-4 col-md-6 col-8 mb-3 d-flex justify-content-center align-items-center flex-wrap gap-3">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.facebook.com/share/1GFaC9x9Np/?mibextid=wwXIfr"
                className="footer-icon facebook"
                style={{ color: "#006effff" }}
              >
                <i className="fa-brands fa-facebook fs-1"></i>
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.tiktok.com/@saleem.smile23?is_from_webapp=1&sender_device=pc"
                className="footer-icon tiktok"
                style={{ color: "#000000" }}
              >
                <i className="fa-brands fa-tiktok fs-1"></i>
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.instagram.com/saleem.smile23/?utm_source=ig_web_button_share_sheet"
                className="footer-icon instagram"
                style={{ color: "#d51717ff" }}
              >
                <i className="fa-brands fa-instagram fs-1"></i>
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://youtube.com/@saleemsmile?si=9AGAT9KM4TMImcAi"
                className="footer-icon youtube"
                style={{ color: "#FF0000" }}
              >
                <i className="fa-brands fa-youtube fs-1"></i>
              </a>
              <a
                href="tel:+970599599591"
                className="footer-icon phone"
                style={{ color: "#00ACE7" }}
              >
                <i className="fa-solid fa-phone fs-1"></i>
              </a>
            </div>

            {/* Column 3 - Logo */}
            <div
              className={`col-lg-4 col-md-6 col-4 mb-3 ${
                isArabic ? "text-lg-start" : "text-lg-end"
              }`}
            >
              <HashLink smooth className="navbar-brand" to="/#home">
                <img src={logo} alt="Logo" width="50" height="50" />
              </HashLink>
            </div>
          </div>
        </div>

        <a
          href="tel:+97022950222"
          className="fs-5 text-center d-block mb-2 text-decoration-none"
          style={{ color: "#9be6ffff" }}
        >
          +97022950222 <i className="fa-solid fa-tty mx-2 fs-3"></i>
        </a>

        {/* Bottom part */}
        <div className="text-center py-3 border-top border-secondary">
          <p className="mb-0">
            {t("footer.rights")}{" "}
            <HashLink
              to="#home"
              className="text-decoration-none"
              style={{ color: "#00ACE7" }}
            >
              {t("footer.brand")}
            </HashLink>{" "}
            © 2025
          </p>
        </div>
      </footer>
    </>
  );
}

export default Footer;
